module.exports = __webpack_public_path__ + "31dc0e663816cbe87d9b498604ff4f28.jpg";